import { Dialog, DialogTitle, DialogContent, IconButton, Typography, Button, DialogActions, } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import { utility } from "../../../utility/utility";
import { ANALYTICS_EVENTS, LOCAL_STORAGE_KEY, PAYMENT_TYPE } from "../../../constant";
import AnalyticsManager from "../../../analytics/analyticsManager";

const PaymentProviderSelectionWeb = ({ open, onClose, paymentProviders = [], onPaymentSuccess, onPaymentFailure, selectedPlan }) => {
    const user = utility.getValue(LOCAL_STORAGE_KEY.user);
    const [selectedId, setSelectedId] = useState(null);
    const handleSelect = (id) => { setSelectedId(id); };

    const handleProceed = async () => {
        const selectedProvider = paymentProviders.find(p => p._id === selectedId);
        if (!selectedProvider) return;
        
        const providerSID = selectedProvider?.SID;
        let isPaymentPage = false;
        switch (providerSID) {
            case PAYMENT_TYPE.Razorpay:
                await utility.openRazorpay({
                    amount: selectedPlan?.Amount, currencyCode: selectedProvider?.currencyCode || "INR", userID: user._id, plan: selectedPlan?._id,
                    onSuccess: (res) => {
                        onPaymentSuccess({...res, plan: selectedPlan});
                        onClose(true);
                    },
                    onFailure: (err) => {
                        onPaymentFailure(err);
                        onClose(false);
                    }
                });
                isPaymentPage = true;
                break;
            case PAYMENT_TYPE.Stripe:
                await utility.openStripe({
                    amount: selectedPlan?.Amount, currencyCode: selectedProvider?.currencyCode || "INR", userID: user._id, plan: selectedPlan,
                });
                isPaymentPage = true;
                break;

            case PAYMENT_TYPE.PayPal:
                await utility.openPaypal({
                    amount: selectedPlan?.Amount, currencyCode: selectedProvider?.currencyCode, userID: user._id, plan: selectedPlan,
                });
                isPaymentPage = true;
                break;

            default:
                toast.warn(`Unsupported provider: ${selectedProvider.Name}`);
                onClose(false);
                break;
        }
        if(isPaymentPage){
            // Analytics event
            AnalyticsManager().logEvent(ANALYTICS_EVENTS.PAYMENT_PAGE, user);
        } 
    };

    return (
        <Dialog
            open={open}
            onClose={() => onClose(false)}
            aria-labelledby="payment-provider-dialog-title"
            maxWidth={false}
            PaperProps={{
                style: {
                    backgroundColor: "#1a1c24",
                    color: "white",
                    padding: "20px",
                    borderRadius: "12px",
                    position: "relative",
                    width: "450px",
                },
            }}
        >
            {/* Close Icon */}
            <IconButton
                onClick={() => onClose(false)}
                sx={{ position: "absolute", top: 10, right: 10, color: "white" }}
            >
                <i className="fa fa-times" style={{ fontSize: "24px" }}></i>
            </IconButton>

            {/* Title */}
            <DialogTitle
                id="payment-provider-dialog-title"
                sx={{ textAlign: "center", marginTop: "20px" }}
            >
                <Typography variant="h6" fontWeight="bold">
                    Select Payment Provider
                </Typography>
                <Typography
                    variant="body2"
                    sx={{ textAlign: "center", marginTop: "5px", color: "#aaa" }}
                >
                    Choose a provider to proceed with payment
                </Typography>
            </DialogTitle>

            {/* Provider List */}
            <DialogContent>
                {paymentProviders.length === 0 ? (
                    <Typography
                        variant="body2"
                        sx={{ textAlign: "center", color: "#ccc", marginTop: "40px" }}
                    >
                        No providers available
                    </Typography>
                ) : (
                    paymentProviders.map((provider) => {
                        const isSelected = selectedId === provider._id;
                        return (
                            <div
                                key={provider._id}
                                onClick={() => handleSelect(provider._id)}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "16px",
                                    marginBottom: "12px",
                                    background: isSelected ? "#007bff" : "#2a2c35",
                                    borderRadius: "12px",
                                    cursor: "pointer",
                                    border: isSelected ? "2px solid #4a9eff" : "1px solid #444",
                                    transition: "0.3s ease",
                                }}
                            >
                                <Typography
                                    variant="body1"
                                    fontWeight="bold"
                                    style={{ color: isSelected ? "white" : "#eee" }}
                                >
                                    {provider.brandingName}
                                </Typography>
                                <div
                                    style={{
                                        backgroundColor: isSelected ? "#005fc4" : "#444",
                                        color: "white",
                                        padding: "6px 14px",
                                        borderRadius: "16px",
                                        fontSize: "13px",
                                        fontWeight: 500,
                                    }}
                                >
                                    {isSelected ? "Selected" : "Select"}
                                </div>
                            </div>
                        );
                    })
                )}
            </DialogContent>

            {/* Proceed Button Only When Selected */}
            {selectedId && (
                <DialogActions
                    style={{
                        justifyContent: "flex-end",
                        marginTop: "8px", // Reduced margin
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={handleProceed}
                        style={{
                            backgroundColor: "#007bff",
                            color: "#fff",
                            borderRadius: "8px",
                            padding: "8px 20px",
                            textTransform: "none",
                            fontWeight: "bold",
                            fontSize: "14px",
                        }}
                    >
                        Proceed&nbsp;→
                    </Button>
                </DialogActions>
            )}
        </Dialog>
    );
};

export default PaymentProviderSelectionWeb;
